import api from "../../utils/apiPublic";
    
export const getInicioStore = async () => {
  const res = await api.get("/api/public/inicio");
  return res.data;
};
